import { render } from "./FieldSelectionStep.vue?vue&type=template&id=0b2e2d8b"
import script from "./FieldSelectionStep.vue?vue&type=script&lang=js"
export * from "./FieldSelectionStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__